import { getElements } from '../config/elements';
import GraphActions from '../actions/graph';
import GraphSource from '../sources/graph';
import createSnapshot from '../sources/snapshot';
import translations from '../translations';

export default {

    printGraph(graphName, graphDate, graphSummary, mapElements, flowId, editingToken, tenantId, authenticationToken) {
        let html = `<!DOCTYPE html><html>
            <head>
                <title>${graphName}</title>
                <style type="text/css">
                td { font-family: Verdana; font-size: 12pt; } body { font-family: Verdana; font-size: 12pt; }
                p { font-family: Verdana; font-size: 12pt; margin-top: 0; margin-bottom: 0; } a { font-family: Verdana;
                font-size: 12pt; margin-top: 0; margin-bottom: 0; } .credit { font-family: Verdana; font-size: 8pt;
                color: #000000; } h1 {font-family: Verdana; font-size: 16pt; font-weight: bold; margin-top: 0; margin-bottom: 0; }
                </style>
            </head>
            <body>
                <h1>${graphName}</h1>
                Description: ${graphSummary}<br/>
                Date Modified: ${graphDate}</br>
                <p>&nbsp;</p>`;

        return Promise.all(mapElements.map(mapElement => {
            return GraphSource.getMapElement(mapElement.id, flowId, editingToken, 'map', tenantId, authenticationToken);
        }))
        .then(response => {
            response.forEach(mapElement => {
                html += `<div id="${mapElement.id}"><h3>Element Title: ${mapElement.developerName}</h3>
                    Content: ${mapElement.userContent || 'Empty'}
                    <p>&nbsp;</p>`;

                if (mapElement.outcomes) {
                    mapElement.outcomes.forEach((outcome) => {
                        const nextMapElementName = mapElements.filter((element) => manywho.utils.isEqual(element.id, outcome.nextMapElementId, true))[0].developerName;
                        html += `<p>${outcome.label}: <a href="#${outcome.nextMapElementId}">${nextMapElementName}</a></p>`;
                    });
                }
            });

            for (var j = 0; j < 20; j++) {
                html += '<p>&nbsp;</p>';
            }

            const link = document.createElement('a');
            link.setAttribute('href', 'data:text/html;charset=utf-8,' + encodeURIComponent(html));
            link.setAttribute('download', graphName + '.html');
            link.setAttribute('target', '_blank');
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    },

    /**
     * @param {String} flowId
     * @param {String} tenantId
     * @param {String} editingToken
     * @param {String} authenticationToken
     * @param {Function} addNotification
     * @param {String} x the X coordinate of the duplicated map element
     * @param {String} y the Y coordinate of the duplicated map element
     * @description Duplicates a map element from mx clipboard
     */
    duplicateMapElement(flowId, tenantId, editingToken, authenticationToken, addNotification, x = null, y = null, mxClipboard) {
        const cellInClipboard = mxClipboard.getCells();
        if (cellInClipboard) {
            const elementConfig = getElements();
            const cellConfig = elementConfig.find(
                element => manywho.utils.isEqual(element.style, cellInClipboard.style),
            );

            GraphSource.getMapElement(
                cellInClipboard.id,
                flowId,
                editingToken,
                (cellConfig.isGroupCell ? 'group' : 'map'),
                tenantId,
                authenticationToken,
            )
                .then((response) => {
                    const newDeveloperName = `${response.developerName} copy`;
                    const newYCoordinate = response.y + cellInClipboard.geometry.height + 30;

                    response.id = null;
                    response.whoCreated = null;
                    response.whoModified = null;
                    response.whoOwner = null;
                    response.developerName = newDeveloperName;
                    response.x = x || response.x;
                    response.y = y || newYCoordinate;
                    response.outcomes = [];
                    response.groupElementId = '';
                    response.navigationOverrides = null;

                    return GraphSource.saveMapElement(
                        response,
                        flowId,
                        editingToken,
                        (cellConfig.isGroupCell ? 'group' : 'map'),
                        tenantId,
                        authenticationToken,
                    );
                })
                .then(() => {

                    // We are creating a snapshot of the flow as a workaround
                    // so that all dependencies associated to the map element
                    // are shared with the flow
                    createSnapshot(authenticationToken, tenantId, flowId)

                        // This action is called so that the graph component props are "refreshed"
                        .then(() => GraphActions.get(flowId, tenantId, authenticationToken));
                })
                .catch(() => {
                    GraphActions.onError(flowId, translations['map element dupe error message']);
                });
        } else {
            addNotification({
                type: 'error',
                message: translations['empty clipboard'],
                isPersistent: false,
            });
        }
    },

    /**
    * @param {String} valueName The name of the component to read the data of
    * @param {Object} response The page response from the engine
    * @description Uses the name of a component to get the data from a page response
    */
    getComponentDataFromResponse(valueName, response) {
        // Find the component by name and get the id
        const componentId = response.mapElementInvokeResponses[0].pageResponse.pageComponentResponses.filter(
            component => component.developerName.toLowerCase() === valueName.toLowerCase(),
        )[0].id;
        // Use the id to get the data for the component
        const componentData = response.mapElementInvokeResponses[0].pageResponse.pageComponentDataResponses.filter(
            component => component.pageComponentId.toLowerCase() === componentId.toLowerCase(),
        )[0];

        return componentData;
    },
};
